import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService } from '../../Services/invoice.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { InvoiceHistoryDate } from '../../Services/invoiceAddendumListViewModel';
import { FileDownloadService } from 'src/app/services/file-download.service';

@Component({
  selector: 'app-download-historical-invoices',
  templateUrl: './download-historical-invoices.component.html',
  styleUrls: ['./download-historical-invoices.component.less']
})
export class DownloadHistoricalInvoicesComponent implements OnInit {

  public fromDate: moment.Moment = moment();
  public toDate: moment.Moment = moment();
  public processing : boolean = false;
  invoicingDates : InvoiceHistoryDate[] = [];
  invoicingYears : number[] = [];
  
  public get invoicingMonths() : number[] {
    if(!this.selectedYear) return [];
    return this.invoicingDates.filter(id => {return id.year == this.selectedYear}).map(id => {return id.month}).sort((a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    });;

  }
  
  selectedYear : number;
  selectedMonth : number;
  constructor(
    private invoiceSrv : InvoiceService,
    public readonly modalService: NgbModal,
    private toasterService: ToastrService,
    private readonly invoiceService: InvoiceService,
    private fileDownload: FileDownloadService
    ) { }

  ngOnInit() {
    this.invoiceSrv.getInvoiceHistoryMonthAndYears().subscribe(
      (scc:any)=>{
        scc.forEach(element => {
          this.invoicingDates.push(new InvoiceHistoryDate(element));
        });
        this.invoicingYears = _.uniq(this.invoicingDates.map(id=>{return id.year}));
      },
      (err:any)=>{
        this.toasterService.error('Please Contact development for assistance','Error Loading Invoice History')
      })
  }
  
  getMonthName(month:number): string{
    return moment().month(month -1).format('MMMM');
  }


  download() : void {
    this.fromDate = moment([this.selectedYear, this.selectedMonth -1]);
    this.toDate = moment([this.selectedYear, this.selectedMonth -1]).endOf('month');
    console.log(`downloading for range FROM: ${this.fromDate} TO: ${this.toDate}`);
    if(this.fromDate === this.toDate) {
      this.toasterService.error('From and To dates must be different', '', { closeButton: true, disableTimeOut: true });
      return;
    }
    if(this.fromDate > this.toDate) {
      this.toasterService.error('To date must be after From date.', '', { closeButton: true, disableTimeOut: true });
      return;
    }

    this.processing = true;
    this.toasterService.info("Beginning invoice download... this action may take several minutes.", '', { timeOut: 10000, closeButton: true });
    this.invoiceService.downloadInvoices(this.toDate, this.fromDate).subscribe((res : Blob) => {
      if (res) {
        this.fileDownload.HandleFileDownload(res, 'zip', `${this.fromDate} - ${this.toDate} invoices.zip`);
        this.modalService.dismissAll();
      } else {
        this.toasterService.error('No invoices found.', '', { closeButton: true, disableTimeOut: true });
      }
      this.processing = false;
    },
    (err) => {
      this.toasterService.error('There was an error fetching invoices.', '', { disableTimeOut: true, closeButton: true });
      this.processing = false;
    });
  }

  cancel() : void {
    this.modalService.dismissAll();
  }

  

}
